import { CommonModule, Location } from '@angular/common';
import { Component, computed, effect } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonService, UserService } from '@tw/services';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { TimeInputDirective } from 'src/shared/components/time-entry/time-input.directive';
import {
  BACK_DATE_ENTRY,
  Department,
  UserDetails,
  UserLookup,
} from 'src/shared/models/common';
import { PermissionAction, PermissionSubject } from 'src/shared/models/permissions';
import { ProjectUserMappingService } from 'src/shared/services/teams.services';
@Component({
  selector: 'tw-my-info',
  imports: [
    SkeletonModule,
    CardModule,
    CommonModule,
    ButtonModule,
    SelectModule,
    FloatLabelModule,
    FormsModule,
    TableModule,
    DialogModule,
    ReactiveFormsModule,
    MultiSelectModule,
    FloatLabelModule,
    SelectModule,
    FormsModule,
    FloatLabelModule,
    DialogModule,
    CommonModule,
    ButtonModule,
    CardModule,
    SkeletonModule,
    TableModule,
    ReactiveFormsModule,
    CommonModule,
    InputTextModule,
    CheckboxModule,
    TimeInputDirective,
    InputNumberModule,
  ],
  templateUrl: './my-info.component.html',
})
export class MyInfoComponent {
  //userDetails: any = null;
  selectedProject: (any & { fullName: string }) | null = null;
  backDateEntry: typeof BACK_DATE_ENTRY = BACK_DATE_ENTRY;
  projectFilterOption: any[] = [];
  selectedRole: (any & { fullName: string }) | null = null;
  projectRoleFilterOption: any[] = [];
  projects: any[] = [];
  users: UserLookup[] = [];
  filteredProjects: any[] = [];
  selectedProjects: any[] = [];
  currentAssignedProjects: any[] = [];
  userEditForm!: FormGroup;
  secondaryReportingManageruserEditForm!: FormGroup;
  rolesOption: { name: string; id: number }[] = [];
  locationOption: { name: string; id: number; timeZone: string | undefined }[] =
    [];
  managerOptions: { name: string; id: number }[] = [];
  usersUnderManager: UserDetails[] = [];
  userMetadata = computed(() => this.userService.userMetadata());
  userDetails = computed(() => this.userService.userDetails());

  get CanUpdateSecondaryManager(): boolean {
    return this.userService.hasPermission(
      PermissionSubject.User,
      PermissionAction.UpdateSecondaryReportingManager,
    );
  }
  constructor(
    //private router: Router,
    private commonService: CommonService,
    private userService: UserService,
    private projectUserMappingService: ProjectUserMappingService,
    private fb: FormBuilder,
    private location: Location,
  ) {
    this.projects = [];

    effect(() => {
      const details = this.userDetails();
      const meta = this.userMetadata();
      this.filteredProjects = [...(meta?.projectMappingResponses || [])];
      if (details && !this.userEditForm) {
        void this.loadUserForm();
      }
    });
  }
  locations: Location[] = [];
  departments: Department[] = [];
  userId!: string;

  allowEmployeeCode(event: KeyboardEvent) {
    const regex = /^[a-zA-Z0-9-]$/;
    const key = event.key;
    if (!regex.test(key)) {
      event.preventDefault();
    }
  }
  backToMyUsersScreen() {
    this.location.back();
  }
  private async loadUserForm() {
    if (this.userDetails()?.isReportingManager) {
      this.users = (await this.userService.getUserLookups()).filter(
        (u) => u.id !== this.userDetails()?.id,
      );
      this.usersUnderManager = this.userDetails()?.reportingUsers || [];
    }
    this.userEditForm = this.fb.group({
      firstName: [{ value: this.userDetails()?.firstName, disabled: true }],
      lastName: [{ value: this.userDetails()?.lastName, disabled: true }],
      emailId: [{ value: this.userDetails()?.emailId, disabled: true }],
      timeZone: [{ value: this.userDetails()?.timeZone, disabled: true }],
      departmentName: [
        { value: this.userDetails()?.departmentName, disabled: true },
      ],
      roleId: [{ value: this.userDetails()?.roleName || null, disabled: true }],
      locationId: [{ value: this.userDetails()?.locationId, disabled: true }],
      departmentId: [
        { value: this.userDetails()?.departmentName, disabled: true },
      ],
      locationName: [
        { value: this.userDetails()?.locationName, disabled: true },
      ],
      roleName: [{ value: this.userDetails()?.roleName, disabled: true }],
      timeCaptureScheme: [
        { value: this.userDetails()?.timeCaptureScheme, disabled: true },
      ],
      userShiftId: [
        { value: this.userDetails()?.userShiftName, disabled: true },
      ],
      dayCountForBackDatedEntry: [
        {
          value: this.userDetails()?.dayCountForBackDatedEntry,
          disabled: true,
        },
      ],
      managerId: this.userDetails()?.reportingManagerId,
      reportingManager: [
        { value: this.userDetails()?.reportingManagerName, disabled: true },
      ],
      minHours: [
        {
          value: this.userDetails()?.minHours?.slice(0, 5) || '',
          disabled: true,
        },
      ],
      isActive: [{ value: this.userDetails()?.isActive, disabled: true }],
      isReportingManager: [
        { value: this.userDetails()?.isReportingManager, disabled: true },
      ],
      secondaryReportingManagerName: [
        {
          value: this.userDetails()?.secondaryReportingManagerName,
          disabled: true,
        },
      ],
      employeeCode: [
        {
          value: this.userDetails()?.employeeCode || '',
          disabled: true,
        },
      ],
    });
    this.secondaryReportingManageruserEditForm = this.fb.group({
      secondaryReportingManagerId: this.userDetails()?.reportingUsers?.find(
        (x) => x.reportingManagerId === this.userDetails()?.id,
      )?.secondaryReportingManagerId,
    });

    this.userEditForm.get('locationId')?.valueChanges.subscribe((locId) => {
      const selected = this.locationOption.find((l) => l.id === locId);
      if (selected) {
        this.userEditForm.patchValue({
          timeZone: selected.timeZone,
        });
      }
    });
  }
  getAssigneeStyles(username: any) {
    const { bgColor, fgColor } = this.commonService.getColorsForName(username);
    return {
      'background-color': bgColor,
      color: fgColor,
      width: '28px',
      height: '28px',
      fontSize: '12px',
    };
  }
  getUserInitials(firstName: any, lastName: any): string {
    return this.commonService.getUserInitials(firstName, lastName) || '';
  }
  async updateUser() {
    try {
      await this.userService.updateSecondaryReportingManagers(
        this.secondaryReportingManageruserEditForm.value
          .secondaryReportingManagerId,
      );
      this.userService.resetUserDetails();
      this.commonService.showToast('Success', 'User updated successfully!');
    } catch (error) {
      this.commonService.showToast(
        'Error',
        'Failed to update user. Please try again.',
      );
    }
  }
}
